export const formataExibicaoMaterialParaTabela = (materialNumber, materialDescription) => {
  if (typeof materialNumber === 'function') {
    return materialNumber;
  }
  return !materialNumber || !materialDescription ? `${materialNumber}` : `${materialNumber.slice(10)} - ${materialDescription}`
}

export const validValue = value => !value || value === 'NULL' ? '-' : value
